var _path, _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentSearches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.25C5.5875 2.25 5.25 2.5875 5.25 3V6C5.25 6.21 5.3325 6.3975 5.4675 6.5325L6.9675 8.0325C7.1025 8.1675 7.29 8.25 7.5 8.25C7.9125 8.25 8.25 7.9125 8.25 7.5C8.25 7.29 8.1675 7.1025 8.0325 6.9675L6.75 5.6925V3C6.75 2.5875 6.4125 2.25 6 2.25ZM6 0C4.2 0 2.595 0.8025 1.5 2.055V0.75C1.5 0.3375 1.1625 0 0.75 0C0.3375 0 0 0.3375 0 0.75V3.75C0 4.1625 0.3375 4.5 0.75 4.5H3.75C4.1625 4.5 4.5 4.1625 4.5 3.75C4.5 3.3375 4.1625 3 3.75 3H2.655C3.48 2.085 4.6725 1.5 6 1.5C8.4825 1.5 10.5 3.5175 10.5 6C10.5 7.9575 9.2475 9.6075 7.5 10.2225V10.215C7.0275 10.3875 6.5325 10.5 6 10.5C3.5175 10.5 1.5 8.4825 1.5 6C1.5 5.5875 1.1625 5.25 0.75 5.25C0.3375 5.25 0 5.5875 0 6C0 9.315 2.685 12 6 12C6.255 12 6.5025 11.9775 6.75 11.9475C6.765 11.9475 6.78 11.94 6.795 11.94C9.735 11.55 12 9.045 12 6C12 2.685 9.315 0 6 0Z",
    fill: "#C1C4D6"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Recent Searches")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentSearches);
export default __webpack_public_path__ + "static/media/recent-searches.7352afd8.svg";
export { ForwardRef as ReactComponent };